import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.features.revoke-report-access-from-all-primary-categories.UseRevokeReportAccessFromAllPrimaryCategoriesPresenter`

export default defineMessages({
  successToastTitle: {
    id: `${scope}.successToastTitle`,
    defaultMessage: 'Success',
  },
  successToastMessage: {
    id: `${scope}.successToastMessage`,
    defaultMessage:
      '{userFullName} was successfully removed from all {pluralPrimaryOrgCategoryLabel}.',
  },
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'Error',
  },
  errorToastDefaultMessage: {
    id: `${scope}.errorToastDefaultMessage`,
    defaultMessage: 'Something went wrong. Please try again.',
  },
})
